var Sentry = require('@sentry/browser');

module.exports = angular.module('ngSentry', [])
  .config(['$provide', 'ENV', registerDecorator])
  .name;

function registerDecorator($provide, env) {
  var release = env.isProd ? 'bbl-frontend@0.0.0' : 'bbl-frontend@dev';

  if (env.isProd) {
    Sentry.init({
      dsn: env.SENTRY_DSN,
      release: release,
    });
  }

  $provide.decorator('$exceptionHandler', ['$delegate', decorateExceptionHandler]);
}

function decorateExceptionHandler($exceptionHandler) {
  return function angularExceptionHandler (err, cause) {
    $exceptionHandler(err, cause);
    Sentry.captureException(err, {extra: {cause: cause}});
  };
}




/*****************
 ** WEBPACK FOOTER
 ** ./app/common/sentry-service.js
 ** module id = 88
 ** module chunks = 0
 **/